import React from 'react';
import { get } from 'global/lib/lodash';
import AssessmentScore from './index';
import { ScorecardTitle } from './styles';
import { PageBreak } from 'global/components/print/print-view/styles';
import { useLoaded } from 'global/hooks/useLoaded';

export default (props) => {
  const { assessment } = props;

  const cards = get(assessment, 'data.scorecards', []);

  useLoaded(props, [!cards]);

  return (
    <>
      {cards.map((card, i) => {
        return (
          <PageBreak key={i} first={i === 0}>
            <ScorecardTitle>{get(card, 'name')}</ScorecardTitle>
            <AssessmentScore {...props} scIndex={i} />
          </PageBreak>
        );
      })}
    </>
  );
};
